import React from 'react';
import { ShimmerBox, Text } from '@common-fe/common-fe';

import { EMPTY_FIELD_VALUE } from '@/common/constants';
import { useGetOrganizationByIdQuery } from '@/modules/role/queries';

interface Props {
  id?: string;
}
const PartnerLabel: React.FC<Props> = ({
  id = ''
}) => {
  const {data, isLoading} = useGetOrganizationByIdQuery({
    id
  });
  if(isLoading) {
    return (
      <ShimmerBox data-testid="partner-label_loading" height="20px" width="100px"/>
    );
  }
  if(!id ) {
    return (
      <Text data-testid="partner-label_empty">{EMPTY_FIELD_VALUE}</Text> 
    );
  }
  return (
    <Text data-testid="partner-label">{data?.title}</Text>
  );
};

export default PartnerLabel;